

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  RadialLinearScale,
  PointElement,
  LineElement,
  Filler
} from 'chart.js';

import { Bar } from 'react-chartjs-2';
import { useEffect, useState } from 'react';
import { Radar } from 'react-chartjs-2';
import { t } from '../../../content';
import { useLocale } from '../../../locale';
import { metricTitle } from '../localizeAnalytics';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  RadialLinearScale,
  PointElement,
  LineElement,
  Filler,
  Title,
  Tooltip,
  Legend
);

export function CommonBehaviours ({ title, commonBehaviours, missingBehaviours, isLegendVisible = false }) {
  useLocale();
  const [topCommonBehaviours, setTopCommonBehaviours] = useState([])
  const [topMissingBehaviours, setTopMissingBehaviours] = useState([])
  useEffect(()=> {
   setTopCommonBehaviours(commonBehaviours.sort((a,b) => b.average-a.average).slice(0,5))
  },[commonBehaviours])
  useEffect(()=> {
    setTopMissingBehaviours(missingBehaviours.sort((a,b) => b.average-a.average).slice(0,5))
  },[missingBehaviours])

  const options = {
    indexAxis: 'y',
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
      },
      title: {
        display: false,
      }
    },
    scales: {
        x: {
        beginAtZero: true,
        min: 0,
        max: 9,
        ticks: {
          font: { size: 14 },
        },
      },
      y: {
        ticks: {
          font: { size: 14 },
          crossAlign: "far",
        },
      }
    }
  };

  const labels = [];
  let newData = [];
  topCommonBehaviours?.length > 0 && topCommonBehaviours
    .sort((a, b) => b.average - a.average)
    .forEach((data) => {
      labels.push(metricTitle(data.column_id, data.column_name));
      newData.push(data.average);
    });
    topMissingBehaviours?.length > 0 && topMissingBehaviours
    .sort((a, b) => b.average - a.average)
    .forEach((data) => {
      labels.push(metricTitle(data.column_id, data.column_name));
      newData.push(data.average);
    });

  const data = {
    labels,
    datasets: [
      {
        categoryPercentage: 1.0,
        barPercentage: 1.0,
        barThickness: 18,
        data: newData,
        backgroundColor: [...topCommonBehaviours?.map(() => '#00B0A0'), ...topMissingBehaviours?.map(() => '#59287A')]
      }
    ],
  };

  return (
    <div className="mar-25 bottom" style={{width: '100%'}}>
      <p className="l bold">{title || t('analytics.tabs.behaviours')}</p>
      {isLegendVisible && (
        <div className='legends' style={{ display: 'flex', gap: '30px', justifyContent: 'center' }}>
          <span className='legend-item' style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
              <span className='legend-color-box' style={{
                  width: '12px',
                  height: '12px',
                  backgroundColor: '#00B0A0',
                  display: 'inline-block'
              }}></span>
              <span className='legend-label'>{t('analytics.highestMetrics')}</span>
          </span>
          <span className='legend-item' style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
              <span className='legend-color-box' style={{
                  width: '12px',
                  height: '12px',
                  backgroundColor: '#59287A',
                  display: 'inline-block'
              }}></span>
              <span className='legend-label'>{t('analytics.lowestMetrics')}</span>
          </span>
      </div>
      )}
      <div className="wrapper" style={{minHeight: '300px'}}>
        <Bar data={data} options={options} />
      </div>
    </div>
  )
}

export function CommonCompetencies ({ title, commonComp, missingComp, isLegendVisible = false }) {
  useLocale();
  const [topCommonComp, setTopCommonComp] = useState([])
  const [topMissingComp, setTopMissingComp] = useState([])
  useEffect(()=> {
   setTopCommonComp([...(commonComp || [])].sort((a,b) => b.average-a.average).slice(0,5))
  },[commonComp])
  useEffect(()=> {
    setTopMissingComp([...(missingComp || [])].sort((a,b) => b.average-a.average).slice(0,5))
  },[missingComp])

  const options = {
    indexAxis: 'y',
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
      },
      title: {
        display: false,
      }
    },
    scales: {
        x: {
        beginAtZero: true,
        min: 0,
        max: 9,
        ticks: {
          font: { size: 14 },
        },
      },
      y: {
        ticks: {
          font: { size: 14 },
          crossAlign: "far",
        },
      }
    }
  };

  const labels = [];
  let newData = [];
  topCommonComp?.length > 0 && topCommonComp
    .sort((a, b) => b.average - a.average)
    .forEach((data) => {
      labels.push(metricTitle(data.column_id, data.column_name));
      newData.push(data.average);
    });
    topMissingComp?.length > 0 && topMissingComp
    .sort((a, b) => b.average - a.average)
    .forEach((data) => {
      labels.push(metricTitle(data.column_id, data.column_name));
      newData.push(data.average);
    });

  const data = {
    labels,
    datasets: [
      {
        categoryPercentage: 1.0,
        barPercentage: 1.0,
        barThickness: 18,
        data: newData,
        backgroundColor: [...topCommonComp?.map(() => '#00B0A0'), ...topMissingComp?.map(() => '#59287A')],
      }
    ],
  };

  return (
    <div className="mar-25 bottom" style={{width: '100%'}}>
      <p className="l bold">{title || t('analytics.tabs.workStyles')}</p>
      {isLegendVisible && (
        <div className='legends' style={{ display: 'flex', gap: '30px', justifyContent: 'center' }}>
          <span className='legend-item' style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
              <span className='legend-color-box' style={{
                  width: '12px',
                  height: '12px',
                  backgroundColor: '#00B0A0',
                  display: 'inline-block'
              }}></span>
              <span className='legend-label'>{t('analytics.highestMetrics')}</span>
          </span>
          <span className='legend-item' style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
              <span className='legend-color-box' style={{
                  width: '12px',
                  height: '12px',
                  backgroundColor: '#59287A',
                  display: 'inline-block'
              }}></span>
              <span className='legend-label'>{t('analytics.lowestMetrics')}</span>
          </span>
      </div>
      )}
      <div className="wrapper" style={{minHeight: '300px'}}>
        <Bar data={data} options={options} />
      </div>
    </div>
  )
}

export function TeamStrengthsChart ({ teamStrengthData }) {


  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
      },
      title: {
        display: false,
      }
    },
    scales: {
      r: {
        min: 0,
        max: 8,
        ticks: {
          stepSize: 1, // the number of step
        },
        grid: {
          circular: true
        },
        beginAtZero: true
      }
    }
  };
  let roundedData = []
  if (teamStrengthData && teamStrengthData.length > 0) {
    roundedData = [teamStrengthData[0]?.average, teamStrengthData[1]?.average,
      teamStrengthData[2]?.average, teamStrengthData[3]?.average,
      teamStrengthData[4]?.average, teamStrengthData[5]?.average,
      teamStrengthData[6]?.average, teamStrengthData[7]?.average, teamStrengthData[8]?.average]

    roundedData = roundedData.map((value) => Math.round(value));
  }


  const data = {
    labels: ['Service Orientation', 'Analysis', 'Innovation', 'Planning and Organization',
      'Initiative and Responsibility', 'Coordination', 'Co-operation', 'Quality Control', 'Influence'],
    datasets: [
      {
        label: t('analytics.highestValue'),
        data: roundedData,
        backgroundColor: 'rgba(53, 196, 220, 0.2)',
        borderColor: 'rgb(53, 196, 220)',
        borderWidth: 1,
      },
    ]
  };
  return <Radar data={data} options={options} />;
}

export function SalesProcessStrengths ({ salesData }) {

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
      },
      title: {
        display: false,
      }
    },
    scales: {
      r: {
        min: 0,
        max: 5,
        ticks: {
          stepSize: 1, // the number of step
        },
        grid: {
          circular: true
        },
        beginAtZero: true
      }
    }
  };

  const data = {
    labels: ['Preparing The Ground', 'Identifying Opportunities', 'Contacting Potential Customers', 'Establishing Relationships',
      'Preparing a Solution', 'Making The Deal', 'Delivering to Promise', 'Ensure Customer Satisfaction'],
    datasets: [
      {
        label: t('analytics.highestValue'),
        data: [salesData?.preparing_the_ground, salesData?.identifying_opportunities,
        salesData?.contacting_potential_customers, salesData?.establishing_relationships,
        salesData?.preparing_a_solution, salesData?.making_the_deal,
        salesData?.delivering_to_promise, salesData?.ensure_customer_satisfaction],
        backgroundColor: 'rgba(53, 196, 220, 0.2)',
        borderColor: 'rgb(53, 196, 220)',
        borderWidth: 1,
      },
    ]
  };
  return <Radar data={data} options={options} />;
}
